<template>
  <transition
    appear
    enter-active-class="ease-in-out duration-100 transform"
    enter-from-class="-translate-x-full"
    enter-to-class="translate-x-0"
    leave-active-class="ease-in-out duration-100 transform"
    leave-from-class="translate-x-0"
    leave-to-class="-translate-x-full"
  >
    <div class="absolute left-80px top-0 h-full w-340px flex flex-col bg-white shadow-btn-card">
      <slot name="header" />
      <div class="flex-1 overflow-x-hidden overflow-y-auto scrollbar">
        <slot name="content" />
      </div>
    </div>
  </transition>
</template>
